/**
 * RTWO Native Currency Engine — Null Storage Adapter
 */

import type { IStorageAdapter, StorageAdapterStatus } from './storage-adapter-interface';

export class NullStorageAdapter implements IStorageAdapter {
  readonly adapterId = 'null-storage-adapter';
  readonly adapterName = 'Null Storage Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): StorageAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  isGenesisConfigurationStored(): boolean {
    return false;
  }
}
